/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue'

import iView from 'iview'
import 'iview/dist/styles/iview.css'
import locale from 'iview/dist/locale/en-US'
import 'element-ui/lib/theme-chalk/index.css'
import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import localeEUI from 'element-ui/lib/locale'
import vMoney from 'v-money'
import Vuelidate from 'vuelidate'

import '@fortawesome/fontawesome-pro/js/all'

// kinf components
import './KinfComponentsBootstrap'
require('./bootstrap')

// window.Vue = require('vue')

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(iView, { locale })
Vue.use(wysiwyg, {})

Vue.use(ElementUI)
localeEUI.use(enLocale)

Vue.use(vMoney, { precision: 4 })
Vue.use(Vuelidate)

// global components
Vue.component('kinfApp', require('./components/KinfApp'))

// eslint-disable-next-line no-unused-vars
const app = new Vue({
  el: '#app',
  data: {
    disabledBtn: false,
    footerBar: window.App.globalData.footerBar
  }
})



// WEBPACK FOOTER //
// ./resources/js/app.js